export const navItems = [
  { label: '首页', href: '/' },
  { label: '使用指南', href: '/category/guide' },
  { label: '平台功能', href: '/category/features' },
  { label: '常见问题', href: '/category/faq' },
  { label: '关于我们', href: '/about' },
];

export const footerQuickLinks = [
  { label: '平台入口', href: '/category/guide' },
  { label: '注册登录', href: '/article/register-login' },
  { label: '功能概览', href: '/category/features' },
  { label: '使用教程', href: '/category/guide' },
  { label: '常见问题', href: '/category/faq' },
];

export const footerSupportLinks = [
  { label: '帮助中心', href: '/category/faq' },
  { label: '联系我们', href: '/about#contact' },
  { label: '用户协议', href: '/article/terms' },
  { label: '隐私政策', href: '/article/privacy' },
];

export const footerAboutLinks = [
  { label: '品牌介绍', href: '/about' },
  { label: '平台声誉', href: '/about#reputation' },
  { label: '最新动态', href: '/category/features' },
];